import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { useFlags } from "launchdarkly-react-client-sdk"
import { useCurrentUser } from "../../../context/user/UserContext"
import { getProviderTypeStepDecision } from "../../utils/providerSelectionUtils"

/**
 * Determines whether to show the "What kind of provider" step before collecting clinic name.
 * Shows for: US members on IUI-related stages, EXPLORING, and MIGHT_WANT_IUI_IVF (ASSISTED_REPRODUCTION only).
 * Skips for: IVF stages and preservation journeys.
 */
export default function WhatKindOfProviderDecisionStep(): JSX.Element {
  const routingData = useCheckRoutingInfoQueryCache()
  const { memberProviderSelectionInRoutingEnabled } = useFlags()
  const { isUsa } = useCurrentUser()

  const decisionValue = getProviderTypeStepDecision(
    isUsa,
    routingData?.journey ?? null,
    routingData?.journeyStage ?? null,
    memberProviderSelectionInRoutingEnabled
  )

  const { send } = useStateMachine()
  useEffect(() => {
    send(decisionValue)
  })

  return <></>
}
